import { styled } from 'styled-components';

import { FormGroup as FormGroupCus } from '../../../withdraw-form/styles';

const InputField = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap: 16px;
  align-self: stretch;
  background: #27262b;
  border-radius: 8px;
`;

const FormItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  text-align: left;
`;

const FormGroup = styled(FormGroupCus)`
  display: ${(props) => (props.$isHidden ? 'none' : 'flex')};
  margin-top: 0;
  gap: 12px;
`;

export { InputField, FormItem, FormGroup };
